<div fxFill class="mat-typography" dir="ltr" i18n-dir>
  <router-outlet></router-outlet>
</div>
